import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Role, ROLES } from '@sodamnfoolish/spl-factory-backend-automatization';

export function useUrlParams() {
    const location = useLocation();
    const [bgColor, setBgColor] = useState<string>('');
    const [node, setNode] = useState<string>('');
    const [csv, setCsv] = useState<string>('');
    const [role, setRole] = useState<string>('');
    const [sessionId, setSessionId] = useState<string>('0');
    const [autoRefresh, setAutoRefresh] = useState<string>('');
    const [automatization, setAutomatization] = useState<{
        room: string;
        role: Role;
    }>();
    const [autoAction, setAutoAction] = useState<string>('');
    const [scannerConnectionIndex, setScannerConnectionIndex] = useState<number>(0);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const bgColorParam = urlParams.get('bgcolor');
        const nodeParam = urlParams.get('node');
        const csvParam = urlParams.get('csv');
        const roleParam = urlParams.get('role');
        const sessionIdParam = urlParams.get('sessionId');
        const autoRefreshParam = urlParams.get('autoRefresh');
        const automatizationParam = urlParams.get('automatization');
        const autoActionParam = urlParams.get('autoAction');
        const scannerConnectionIndex = urlParams.get('scanner-connection-index');

        setBgColor(bgColorParam || '');
        setNode(nodeParam || '');
        setCsv(csvParam || '');
        setRole(roleParam || '');
        setSessionId(sessionIdParam || '');
        setAutoRefresh(autoRefreshParam || '');
        if (automatizationParam) {
            const [room, role] = automatizationParam.split(':');
            if (!ROLES.some((_) => _ == role)) throw new Error('Invalid role provided in url params');
            setAutomatization({ room, role: role as Role });
        }
        setAutoAction(autoActionParam || '');
        setScannerConnectionIndex(Number(scannerConnectionIndex) || 0);
    }, [location.search]);

    return { bgColor, node, csv, role, sessionId, autoRefresh, automatization, autoAction, scannerConnectionIndex };
}
